/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { CustomArrow } from './customArrow';
import './slickSlider.less';
import { TranslationProps, WithCoreProps } from 'ff-shared-components-core';

export interface SliderProps {
	/** set LinkLabel id */
	id?: string;
	/** set target */
	list?: React.ReactNode[];
	/**sets the number of items to render in each slide */
	itemsPerSlide: number; // default is 5
	/**sets the total number of items */
	itemsLength?: number; // default is 5
	/**set arrows */
	withArrows?: boolean;
}

export interface SliderState {
	index: number;
	currentSlide: number;
}

export type SliderInjectedProps = TranslationProps;

class SlickSliderComponent extends React.Component<SliderProps & SliderInjectedProps, SliderState> {
	constructor(props: SliderProps & SliderInjectedProps) {
		super(props);

		this.state = {
			index: 0,
			currentSlide: 0,
		};
	}

	afterChange = (currentSlide: number): void => {
		this.setState({ currentSlide });
	};

	render(): React.ReactNode {
		const { list, itemsLength = 6, itemsPerSlide = 5, withArrows = false } = this.props;
		const { currentSlide } = this.state;

		const isEven = itemsLength % 2 === 0;

		const settings = {
			dots: true,
			infinite: false,
			adaptiveHeight: true,
			speed: 200,
			slidesToShow: itemsPerSlide,
			slidesToScroll: 1,
			arrows: false,
			className: 'slides',
			initialSlide: 0,
			afterChange: this.afterChange,
			prevArrow: currentSlide === 0 ? undefined : <CustomArrow />,
			nextArrow: isEven ? (
				currentSlide >= Math.round(itemsLength / itemsPerSlide) ? (
					undefined
				) : (
					<CustomArrow />
				)
			) : currentSlide > Math.round(itemsLength / itemsPerSlide) ? (
				undefined
			) : (
				<CustomArrow />
			),
			responsive: [
				{
					breakpoint: 1800,
					settings: {
						slidesToShow: itemsPerSlide,
						slidesToScroll: 1,
						adaptiveHeight: true,
						infinite: false,
						arrows: false,
						dots: true,
						nextArrow: isEven ? (
							currentSlide >= Math.round(itemsLength / 4) ? (
								undefined
							) : (
								<CustomArrow />
							)
						) : currentSlide > Math.round(itemsLength / 4) ? (
							undefined
						) : (
							<CustomArrow />
						),
					},
				},
				{
					breakpoint: 1500,
					settings: {
						slidesToShow: 4, // itemsPerSlide,
						slidesToScroll: 1,
						adaptiveHeight: true,
						infinite: false,
						arrows: false,
						dots: true,
						nextArrow: isEven ? (
							currentSlide <= Math.round(itemsLength / 3) ? (
								<CustomArrow />
							) : (
								undefined
							)
						) : currentSlide >= Math.round(itemsLength / 3) ? (
							undefined
						) : (
							<CustomArrow />
						),
					},
				},
				{
					breakpoint: 1084,
					settings: {
						slidesToShow: 3, // itemsPerSlide - 1 < 1 ? 1 : itemsPerSlide - 1,
						slidesToScroll: 1,
						adaptiveHeight: true,
						infinite: false,
						arrows: false,
						dots: true,
						nextArrow: isEven ? (
							currentSlide >= Math.round(itemsLength / 2) ? (
								undefined
							) : (
								<CustomArrow />
							)
						) : currentSlide > Math.round(itemsLength / 2) ? (
							undefined
						) : (
							<CustomArrow />
						),
					},
				},
				{
					breakpoint: 830,
					settings: {
						slidesToShow: 2, //itemsPerSlide - 2 < 1 ? 1 : itemsPerSlide - 2,
						slidesToScroll: 1,
						centerMode: false,
						adaptiveHeight: true,
						infinite: false,
						arrows: false,
						dots: true,
						nextArrow: isEven ? (
							currentSlide === itemsLength - 1 ? (
								undefined
							) : (
								<CustomArrow />
							)
						) : currentSlide >= itemsLength - 1 ? (
							undefined
						) : (
							<CustomArrow />
						),
					},
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1, // itemsPerSlide - 3 < 1 ? 1 : itemsPerSlide - 3,
						slidesToScroll: 1,
						centerMode: false,
						adaptiveHeight: true,
						infinite: false,
						arrows: false,
						dots: true,
					},
				},
			],
		};

		return (
			<>
				<Slider {...settings}>
					{list && list.map((item: React.ReactNode, index: number): React.ReactNode => item)}
				</Slider>
			</>
		);
	}
}

export const SlickSlider = WithCoreProps<SliderProps>(SlickSliderComponent);
